/**
 * MediaGrid - 3-column grid for displaying user's media (photos/videos)
 * Based on mobile app ProfileScreenOptimized.tsx
 */

import { Play } from 'lucide-react'

interface MediaItem {
  id: string
  url: string
  type: 'photo' | 'video'
  thumbnail?: string
}

interface MediaGridProps {
  media: MediaItem[]
  onMediaClick?: (item: MediaItem) => void
}

export default function MediaGrid({ media, onMediaClick }: MediaGridProps) {
  if (media.length === 0) {
    return null
  }

  return (
    <div className="grid grid-cols-3 gap-1 p-2">
      {media.map(item => (
        <div
          key={item.id}
          onClick={() => onMediaClick?.(item)}
          className="relative aspect-square cursor-pointer overflow-hidden bg-gray-100 hover:opacity-90 transition-opacity"
        >
          {/* Media Thumbnail */}
          <img
            src={item.thumbnail || item.url}
            alt="Media"
            className="w-full h-full object-cover"
          />

          {/* Video Indicator */}
          {item.type === 'video' && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/20">
              <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center">
                <Play className="w-5 h-5 text-gray-900 fill-gray-900" />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
